import ShareLinkAnalytics from "./ShareLinkAnalytics";

export default ShareLinkAnalytics;
